import Image from 'next/legacy/image';

import { BodyRegular } from '@common/body';

import logo from '@public/img/logo/sn-logo-border-white.svg';

type Props = {
  showIcon: boolean;
  icon?: React.ReactNode;
  title: string;
  desktopTitle?: string;
  mobileTitle?: string;
  showActions: boolean;
  desktopAction?: React.ReactNode;
  mobileAction?: React.ReactNode;
};

export const Banner = ({
  showIcon,
  icon,
  title,
  desktopTitle,
  mobileTitle,
  showActions,
  desktopAction,
  mobileAction,
}: Props): JSX.Element => (
  <>
    <div className="banner-container bg-blue">
      <div className="banner-boundary-container">
        {showIcon && (
          <div className="sn-banner-logo">
            {!icon && (
              <Image src={logo} height={40} width={40} layout="fixed" />
            )}
            {icon}
          </div>
        )}
        <div className="sn-banner-title">
          <div className="sn-banner-title-desktop text-white">
            <BodyRegular>{desktopTitle ? desktopTitle : title}</BodyRegular>
          </div>
          <div className="sn-banner-title-mobile text-white">
            <BodyRegular>{mobileTitle ? mobileTitle : title}</BodyRegular>
          </div>
        </div>
        {showActions && (
          <div className="sn-banner-actions">
            <div className="sn-banner-actions-mobile">{mobileAction}</div>
            <div className="sn-banner-actions-desktop">{desktopAction}</div>
          </div>
        )}
      </div>
    </div>
    <style jsx>{`
      .banner-container {
        width: 100vw;
        flex: 1;
        left: 0;
        margin: auto;
        padding: 0 16px;
      }
      .banner-boundary-container {
        display: flex;
        flex-direction: row;
        max-width: 800px;
        margin: auto;
        height: 100%;
      }
      .sn-banner-actions-mobile {
        display: flex;
      }
      .sn-banner-actions-desktop {
        display: none;
      }
      .sn-banner-title-desktop {
        display: none;
      }
      .sn-banner-title {
        margin: auto;
        max-width: 420px;
        position: relative;
        padding-right: 15px;
      }
      .sn-banner-logo {
        margin: auto;
        padding-right: 15px;
      }
      @media (min-width: 767px) {
        .sn-banner-actions-mobile {
          display: none;
        }
        .sn-banner-actions-desktop {
          display: flex;
        }
        .sn-banner-title-mobile {
          display: none;
        }
        .sn-banner-title-desktop {
          display: flex;
        }
      }
    `}</style>
  </>
);

Banner.defaultProps = {
  showIcon: true,
  showActions: false,
};
